import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import PopUp from "../../components/popup/Popup";
import { useAppDispatch, useAppSelector } from "../../store/customHooks";
import VehicleStatus from "./vehicleStatus";
import { TechnicianHeaderComponent } from "./TechnicianHeaderComponent";
import { TechnicianWorkStatus } from "./technicianWorkStatusComponent";
import VehicleStatusCount from "./vehicleStatusCount";
import {
  workshopDataListAsync,
  addData,
} from "../../redux/actions/workshopSlice";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    marginTop: "3.5%",
  },
  workStatus: {
    // height: "360px",
    // overflow: 'auto',
    verticalAlign: "middle",
    alignItems: "center",
  },
  descriptionBox: {
    height: "121px",
    width: "280px",
    left: "1008px",
    margin: "10px 0px",
    backgroundColor: "#17A6DF",
    borderRadius: "5px",
  },
  descriptionHeading: {
    fontSize: "20px",
    fontWeight: 700,
    display: "flex",
    justifyContent: "center",
    color: "white",
  },
  descriptionText: {
    fontSize: "10px",
    display: "flex",
    justifyContent: "center",
    color: "white",
    marginTop: 10,
  },
  iconButton: {
    color: "#2c3968",
    "&&.css-78trlr-MuiButtonBase-root-MuiIconButton-root": {
      padding: "0px",
      margin: "0px 35px 10px 0px",
    },
  },
  oddRowColor: {
    backgroundColor: "white",
  },
  evenRowColor: {
    backgroundColor: "#EEFAFF",
  },
});

export const WorkShopBoard = (props: any) => {
  const { socket } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [rows, setRows] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<any>([]);
  const [_rows, setRow] = useState<any>([]);
  let _headerList: any = ["Technician"];

  let workshopData = useAppSelector(
    (state: any) => state.workshop.workshopData
  );
  const authData = JSON.parse(localStorage.getItem("AUTH_DATA") || "{}");
  let interval: any = "";
  useEffect(() => {
    getList();
    if (socket) {
      socket.emit("joinRoom", "WorkshopData:" + authData?.CompanyID);
    }
    return () => {
      setData([]);
      setRows([]);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (socket) {
      socket?.on("WorkshopData:" + authData?.CompanyID, (dataSI: any) => {
        if (
          dataSI?.CompanyID == authData?.CompanyID &&
          dataSI?.RelationKey == authData?.referenceData?.defaultBranch
        ) {
          clearInterval(interval);
          getList();
        }
      });
    }
    return () => {
      socket.off("WorkshopData");
    };
  }, [socket]);

  const getList = async () => {
    const payload = {
      CompanyID: authData?.CompanyID.toString(),
    };

    const res: any = await dispatch(workshopDataListAsync(payload));
    if (res?.payload?.success) {
      const data = res?.payload?.data;
      clearInterval(interval);
      setData(data);
      setRows(data?.TechnicianList);
      loadTechnicianList(data?.TechnicianList);
    }
    if (!(res && res?.payload && res?.payload?.success)) {
      setOpen(true);
    }
  };

  const loadTechnicianList = (workData: any) => {
    let endofpage: any = null;
    let startofpage: any = null;

    if (workData?.length > 0) {
      const getRows = (st: number, end: number) => {
        let currentRows = workData.slice(st, end);
        setRows([...currentRows]);
        start = start + pageSize;
        startofpage = start;
        end = end + pageSize;
        endofpage = end;
        pageCount = pageCount - 1;
      };

      let pageSize: number = 8;
      let totalPageCount: number = workData?.length / pageSize;
      let pageCount: number = parseInt(totalPageCount.toFixed());

      let finalPageCount: number = 0;
      if (totalPageCount > pageCount) {
        pageCount = pageCount + 1;
        finalPageCount = pageCount;
      } else finalPageCount = pageCount;

      let start: number = 0;
      let end: number = pageSize;

      getRows(start, end);

      interval = setInterval(() => {
        if (Math.max(pageCount, 0) === 0) {
          pageCount = finalPageCount;
          start = 0;
          end = pageSize;
          startofpage = 0;
          endofpage = 8;

          getRows(startofpage, endofpage);

          return () => {
            clearInterval(interval);
          };
        } else {
          getRows(startofpage, endofpage);
        }
      }, 30000);
    }
  };

  let startTime: any = new Date(data?.WorkshopStartTime).toLocaleString(
    "en-US",
    { hour: "numeric", minute: "numeric", hour12: true }
  );
  let endTime: any = new Date(data?.WorkshopEndTime).toLocaleTimeString(
    "en-US",
    { hour: "numeric", minute: "numeric", hour12: true }
  );
  //let endTime:any = "2023-01-22T21:00:00"
  let workshopStartTime: any = parseInt(
    moment(startTime, "hh:mm a").format("HH")
  );
  let workshopEndTime: any = parseInt(moment(endTime, "hh:mm a").format("HH"));

  let i: any;
  for (i = workshopStartTime; i <= workshopEndTime; i++) {
    let _i = i + ":00";
    _headerList.push(_i);
  }

  const handleClose = () => {
    setOpen(false);
    navigate("/login");
    dispatch({ type: "OnLoginAsync", payload: {} });
    dispatch({ type: "dashBoardListAsync", payload: {} });
    localStorage.removeItem("AUTH_DATA");
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Header position={"fixed"} />
        </Grid>

        <Grid item xs={12}>
          <div className={classes.container}>
            {_headerList?.map((item: any, index: number) => (
              <TechnicianHeaderComponent header={item} index={index} />
            ))}
          </div>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.workStatus}>
            {rows?.map((i: any, ind: any) => (
              <TechnicianWorkStatus
                key={ind}
                name={i.Name}
                data={i.Times}
                index={rows.indexOf(i)}
              />
            ))}
          </div>
        </Grid>

        <Grid item xs={12}>
          <VehicleStatus WorkShopStatusDetails={data?.WorkShopStatusDetails} />
        </Grid>
        <Grid item xs={12}>
          <VehicleStatusCount
            AllVehicleStatusCount={data?.AllVehicleStatusCount}
          />
        </Grid>
      </Grid>
      <PopUp open={open} handleClose={handleClose} />
    </>
  );
};
